import React, { useEffect, useState } from 'react';

export default function OTPTimer({ durations,updateTimer }) {
    
    const [timer, setTimer] = useState(null);
    const [duration, setDuration] = useState(durations);
    let interVal = null
    useEffect(()=>{setDuration(durations)},[duration])
    useEffect(() => {
        var timer = duration, minutes, seconds;
        let interval = setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            if (--timer < -1) {
                clearInterval(interval)
                updateTimer(true)
            } else {
                setTimer(minutes + ":" + seconds)
            }
        }, 1000);
        interVal = interval
    }, [])
    useEffect( () => () =>  clearInterval(interVal), [] );
    return (
        <div>{timer ? `${timer} left`: null} </div>
    )
}
